import { render } from "./AbonnerRestaurant.vue?vue&type=template&id=728088ce&scoped=true"
import script from "./AbonnerRestaurant.vue?vue&type=script&lang=js"
export * from "./AbonnerRestaurant.vue?vue&type=script&lang=js"

import "./AbonnerRestaurant.vue?vue&type=style&index=0&id=728088ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728088ce"]])

export default __exports__